import { useStoreSelector } from 'store/hooks/storeHooks';

export const useIsProductTemplateWanted = () => {
  const { userWants } = useStoreSelector((state) => state.pdp);
  const showWantsCheckmark = userWants?.length > 0;

  return showWantsCheckmark;
};
